import clsx from 'clsx';
import React from 'react';
import styles from '../auth-select/AuthSelect.module.scss';
import { HdIcon, HdLink } from '../../../../components';
import { getDataIdGenerator } from '../../../../core/utils/generateDataId';

export interface INewAuthComponent {
  triggerLabel: string;
  providerClass?: string;
  providerIcon?: string;
  flatButton: boolean;
  onAuthClick: Function;
}

const dataIdGenerator = getDataIdGenerator('new-auth-trigger');
export function NewAuthTrigger({
  triggerLabel,
  providerClass,
  providerIcon,
  onAuthClick,
  flatButton
}: INewAuthComponent) {
  if (flatButton) {
    return (
      <HdLink
        dataId={dataIdGenerator('')}
        icon='plus'
        direction='left'
        className='text-uppercase my-5 ml-5'
        onClick={() => onAuthClick()}
      >
        {triggerLabel}
      </HdLink>
    );
  }

  return (
    <button
      data-id={dataIdGenerator('button')}
      type='button'
      className={clsx(
        'btn',
        providerIcon ? styles[`btn-${providerClass}`] : 'btn-primary btn-thumbnail-left'
      )}
      onClick={() => onAuthClick()}
    >
      {providerIcon ? (
        <img data-id={dataIdGenerator('img')} src={providerIcon} alt={triggerLabel} />
      ) : (
        <HdIcon name='plus' className='thumb' />
      )}
      {triggerLabel}
    </button>
  );
}
